import React, { useCallback, useEffect, useState, Component } from 'react';
import { CoverSlide } from '../components/slides/CoverSlide';
import { ProblemSlide } from '../components/slides/ProblemSlide';
import { SolutionSlide } from '../components/slides/SolutionSlide';
import { HowItWorksSlide } from '../components/slides/HowItWorksSlide';
import { ImpactSlide } from '../components/slides/ImpactSlide';
import { MarketSlide } from '../components/slides/MarketSlide';
import { ClosingSlide } from '../components/slides/ClosingSlide';
export function PitchDeck() {
  const [currentSlide, setCurrentSlide] = useState(1);
  const slides = [CoverSlide, ProblemSlide, SolutionSlide, HowItWorksSlide, ImpactSlide, MarketSlide, ClosingSlide];
  const totalSlides = slides.length;
  const nextSlide = useCallback(() => {
    if (currentSlide < totalSlides) {
      setCurrentSlide(prev => prev + 1);
    }
  }, [currentSlide, totalSlides]);
  const prevSlide = useCallback(() => {
    if (currentSlide > 1) {
      setCurrentSlide(prev => prev - 1);
    }
  }, [currentSlide]);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight' || e.key === 'Space') {
        nextSlide();
      } else if (e.key === 'ArrowLeft') {
        prevSlide();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [nextSlide, prevSlide]);
  const CurrentSlideComponent = slides[currentSlide - 1];
  return <div className="w-full h-screen bg-black" data-id="element-436">
      <CurrentSlideComponent isActive={true} currentSlide={currentSlide} totalSlides={totalSlides} onNext={nextSlide} onPrev={prevSlide} data-id="element-437" />
    </div>;
}